<template>
    <div>
      <section class="section section-lg pt-5 thank-you-section justify-content-center">
        <div class="video-container">
          <video class="thank-you-video" autoplay muted loop playsinline src="../assets/video/thankYouVideo.mp4" type="video/mp4">
          </video>
        </div>
          <div class="justify-content-center">
          <div class="thank-you-text">
            <h1 class="text-white font-weight-bold thank-you-text">Procesando la solicitud de tu LotePerfecto...</h1>
            <p class="text-white thank-you-text font-weight-bold">Pronto nos contactaremos con novedades.</p>
            </div>
          </div>
      </section>

    </div>
  </template>
  <script>
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  const moment = require('moment');

  export default {
    name: "thank-you",
    components: {flatPicker},
    data () {
      return {
        purpose: '',
        anyDate: false,
        services: {
          water: false,
          power: false,
          home: false
        },
        radio: {
        },
        dates: {
          simple: moment().format('YYYY-MM-DD')
        }
      }
    },
    mounted () {
      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'pageview',
          'page_location': this.$route.path,
          'page_title': this.$route.name
      });
    }
  };
  </script>